angular.module('v3sWbtPlayerApp').factory('v3sViewportViewerService', [ function () {
    return {
        activate: function activate() {
            // Damit wird in Viewport-Viewer Scrollbar immer korrekt ausgeblendet
            document.body.style.overflowY ='scroll';
        }
    }
}]);